const authConfig = {
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  },
  
  entraProviderId: process.env.REACT_APP_FIREBASE_ENTRA_PROVIDER_ID,
  postLogoutRedirectUri:
    process.env.REACT_APP_AUTH_POST_LOGOUT_URI,
};

export default authConfig;
